import { configProps } from "../../types/index.ts";
import { Delivery } from "../../types/delivery.ts";
import DeliveryStatusTag from "../../components/DeliveryStatusTag.tsx";
import { getCountryName } from "../../helpers/countryNames.ts";

export const deliveriesConfig: configProps<"deliveries"> = {
  view: "deliveries",
  title: "Dostawy",
  allowMultipleNewEntries: false,
  columns: [
    {
      id: 1,
      field: "source",
      header: "Źródło",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "text",
      editable: false,
      body: (rowData: Delivery) => (
        <>
          <i
            className={
              rowData.source === "TransportOrder"
                ? "pi pi-shopping-bag"
                : "pi pi-truck"
            }
            title={
              rowData.source === "TransportOrder"
                ? "Zlecenie Transportowe"
                : "Spedycja"
            }
          />{" "}
          {rowData.source === "TransportOrder"
            ? "Zlecenie Transportowe"
            : "Spedycja"}
        </>
      ),
    },
    {
      id: 2,
      field: "date",
      header: "Data",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--extra-small",
      inputType: "calendar",
      isDefaultSort: true,
      sortOrder: -1 as const,
    },
    {
      id: 3,
      field: "driver",
      header: "Kierowca",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--flexible",
      inputType: "text",
      editable: false,
      enableFilter: true,
      optionsKey: "drivers",
    },
    {
      id: 4,
      field: "driverManager",
      header: "Kierownik",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--flexible",
      inputType: "text",
      editable: false,
      enableFilter: true,
      optionsKey: "organizationalUsers",
      body: (rowData) => rowData.driverManager ?? "",
    },
    {
      id: 5,
      field: "loadingCountry",
      header: "Kraj zał.",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "text",
      editable: false,
      body: (rowData) => getCountryName(rowData.loadingCountry),
    },
    {
      id: 6,
      field: "loadingCity",
      header: "Miasto zał.",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "text",
      editable: false,
      enableFilter: true,
      optionsKey: "cities",
    },
    {
      id: 7,
      field: "loadingAddress",
      header: "Adres zał.",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "text",
      editable: false,
    },
    {
      id: 8,
      field: "unloadingCountry",
      header: "Kraj rozł.",
      formGroup: "none",
      isDefaultVisible: false,
      className: "column--medium",
      inputType: "text",
      editable: false,
      body: (rowData) => getCountryName(rowData.unloadingCountry),
    },
    {
      id: 9,
      field: "unloadingCity",
      header: "Miasto rozł.",
      formGroup: "none",
      isDefaultVisible: false,
      className: "column--medium",
      inputType: "text",
      editable: false,
      enableFilter: true,
      optionsKey: "cities",
    },
    {
      id: 10,
      field: "unloadingAddress",
      header: "Adres rozł.",
      formGroup: "none",
      isDefaultVisible: false,
      className: "column--medium",
      inputType: "text",
      editable: false,
    },
    {
      id: 11,
      field: "transportRate",
      header: "Stawka Tr.",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "number",
    },
    {
      id: 12,
      field: "deliveryStatus",
      header: "Status dostawy",
      formGroup: "none",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "dropdown",
      optionsKey: "deliveryStatus",
      editable: false,
      enableFilter: true,
      body: (rowData: Delivery) => (
        <DeliveryStatusTag deliveryStatus={rowData.deliveryStatus} />
      ),
    },
  ],
  fieldNameMap: {
    source: "source",
    date: "date",
    driver_id: "driver",
    transport_rate: "transportRate",
    status: "deliveryStatus",
    entry_status: "entryStatus",
    marked_fields: "marked",
    sort_rank: "sortRank",
  },
};
